import { render, staticRenderFns } from "./inquiry-collect.vue?vue&type=template&id=739f74a7&scoped=true&"
import script from "./inquiry-collect.vue?vue&type=script&lang=js&"
export * from "./inquiry-collect.vue?vue&type=script&lang=js&"
import style0 from "./inquiry-collect.vue?vue&type=style&index=0&id=739f74a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739f74a7",
  null
  
)

export default component.exports